import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RoleDataService } from './role-data.service';


@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    { provide: RoleDataService, useClass: RoleDataService, multi: false }
  ]
})
export class RoleDataModule { }
